import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import React, { useEffect, useState } from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import { ExpandMore } from "@mui/icons-material";
import Analatic from "../../analaticsBar";
import CustomerMangementbar from "../../customerMangementBar";
import BillingBarSide from "../../billingSide";
import BussinessMangment from "../../businessChategory";
import InstituteSidebar from "../../instituteSidebar";
import FranchiseSidebar from "../../franchiseSidebar";
import ConsultantSidebar from "../../consultantSidebar";
import WhiteLabelsSidebar from "../../whitelabelSidebar";

const mapComponent = {
  // Analatic:""
};
const AnalaticSideBarT = (breakpoint) => {
  const menuLoginHeader = [
    {
      title: "Home",
    },
    {
      title: "About",
    },
  ];
  const customerChategory = useSelector(
    (state) => state.reducer.customerChategory,
  );
  const barName = useSelector((state) => state.reducer.barName);
  const location = useLocation();
  const bussinessMangementMenu = useSelector(
    (state) => state.reducer.bussinessMangementMenu,
  );
  const analatics = useSelector((state) => state.reducer.analatics);
  const institute = useSelector((state) => state.reducer.institute);
  const franchise = useSelector((state) => state.reducer.franchise);
  const consultant = useSelector((state) => state.reducer.consultant);
  const whitelabels = useSelector((state) => state.reducer.whitelabels);

  const [currentPage, setCurrentPage] = useState(-1);
  const navigate = useNavigate();
  const urlHeaderMenu = useSelector((state) => state.reducer.urlHeaderMenu);
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const NameData = {
    Home: 1,
    "Business Management": 1,
    "Customer Management": 1,
  };
  const [active, setActive] = useState(0);

  const titleHead1 = (ele) => {
    const indexRoute = headerMenu.findIndex(
      (it) => it.systemFuctionName === ele.systemFuctionName,
    );
    if (NameData[ele?.systemFuctionName]) {
      return ele?.systemFuctionName;
    }
    if (headerMenu[indexRoute]?.regionalFunctionName.includes("Counter Sale")) {
      return "Billing";
    }

    return headerMenu[indexRoute]?.regionalFunctionName;
  };
  useEffect(() => {
    //console.log("barName ", urlHeaderMenu);
  }, [urlHeaderMenu]);
  // useEffect(() => {
  //   const index = urlHeaderMenu?.findIndex((item) => {
  //     const tt = titleHead1(item);
  //     if (tt === "Dashboard" && barName === "analatic") {
  //       return location.pathname === analatics[0]?.route;
  //     }
  //     if (tt === "Customer Management" && barName === "CustomerMangment") {
  //       return location.pathname === customerChategory[0]?.route;
  //     }
  //     if (tt === "Business Management" && barName === "bussinessMangment") {
  //       return location.pathname === bussinessMangementMenu[0]?.route;
  //     }
  //     return location.pathname === item?.route;
  //   });

  //   if (index !== -1) {
  //     setActive(index);
  //   }
  // }, [location.pathname, urlHeaderMenu, barName]);
  useEffect(() => {
    const index = urlHeaderMenu?.findIndex((item) => {
      const tt = titleHead1(item);

      // ✅ Dashboard group active for ANY child route
      if (tt === "Dashboard") {
        return analatics?.some((sub) => sub.route === location.pathname);
      }

      // ✅ Customer group active for ANY child route
      if (tt === "Customer Management") {
        return customerChategory?.some(
          (sub) => sub.route === location.pathname,
        );
      }

      // ✅ Business group active for ANY child route
      if (tt === "Business Management") {
        return bussinessMangementMenu?.some(
          (sub) => sub.route === location.pathname,
        );
      }

      if (tt === "My Institute") {
        return institute?.some((sub) => sub.route === location.pathname);
      }
      if (tt === "My Franchise") {
        return franchise?.some((sub) => sub.route === location.pathname);
      }
      if (tt === "Post Consultant Ads") {
        return consultant?.some((sub) => sub.route === location.pathname);
      }
      if (tt === "White Lable") {
        return whitelabels?.some((sub) => sub.route === location.pathname);
      }
      // ✅ Normal menu item active
      return item.route === location.pathname;
    });

    if (index !== -1) {
      setActive(index);
    }
  }, [
    location.pathname,
    urlHeaderMenu,
    analatics,
    customerChategory,
    bussinessMangementMenu,
    institute,
    franchise,
    consultant,
    whitelabels,
  ]);

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        height: breakpoint === "xs" ? "100vh" : "85vh",
        borderRight: "1px solid #eee",
        overflow: breakpoint === "xs" ? "visible" : "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "-ms-overflow-style": "none", // IE and Edge
        "scrollbar-width": "none",
      }}
    >
      <List component="nav">
        {urlHeaderMenu
          ?.filter((item) => {
            const tt = titleHead1(item);

            if (barName === "bussinessMangment")
              return tt === "Business Management";

            if (barName === "CustomerMangment")
              return tt === "Customer Management";

            if (barName === "analatic")
              return item.systemFuctionName === "Dashboard";
            if (barName === "institute")
              return item.systemFuctionName === "My Institute";
            if (barName === "franchise")
              return item.systemFuctionName === "My Franchise";
            if (barName === "consultant")
              return item.systemFuctionName === "Post Consultant Ads";
            if (barName === "whitelabels")
              return item.systemFuctionName === "White Lable";
            if (barName === "billing") return tt === "Billing";

            return true; // default show all
          })
          ?.map((item, index) => {
            // if(urlHeaderMenu.length-1==  index){
            //   return null
            // }
            //console.log("Sidebar Item ===", item);

            const indexRouteRilg = headerMenu.findIndex(
              (it) => it.systemFuctionName === item.systemFuctionName,
            );

            const isRestricted =
              item.systemFuctionName === "Cash Sale Bill" ||
              item.systemFuctionName === "Dashboard";

            if (
              isRestricted &&
              !headerMenu[indexRouteRilg]?.systemFuctionName
            ) {
              return null; // skip rendering
            }
            return (
              <React.Fragment>
                <ListItemButton
                  onClick={async (e) => {
                    e.stopPropagation();

                    let tt = titleHead1(item);
                    setActive(index);
                    //console.log("item systemFuctionName ", tt);
                    if (
                      tt !== "Business Management" &&
                      tt !== "Customer Management"
                    ) {
                    }
                    if (tt === "Business Management") {
                      if (bussinessMangementMenu[0]) {
                        navigate(bussinessMangementMenu[0].route);
                      }
                      return;
                    }
                    if (tt === "Customer Management") {
                      if (customerChategory[0]) {
                        navigate(customerChategory[0].route);
                      }
                      return;
                    }
                    if (tt == "Dashboard") {
                      // console.log(
                      //   "item systemFuctionName ",
                      //   item.systemFuctionName
                      // );
                      if (analatics[0]) {
                        navigate(analatics[0].route);
                      }
                      return;
                    }
                    if (item.systemFuctionName == "My Institute") {
                      // console.log(
                      //   "item systemFuctionName ",
                      //   item.systemFuctionName
                      // );
                      if (institute[0]) {
                        navigate(institute[0].route);
                      }
                      return;
                    }
                    if (item.systemFuctionName == "My Franchise") {
                      // console.log(
                      //   "item systemFuctionName ",
                      //   item.systemFuctionName
                      // );
                      if (franchise[0]) {
                        navigate(franchise[0].route);
                      }
                      return;
                    }
                    if (item.systemFuctionName == "Post Consultant Ads") {
                      // console.log(
                      //   "item systemFuctionName ",
                      //   item.systemFuctionName
                      // );
                      if (consultant[0]) {
                        navigate(consultant[0].route);
                      }
                      return;
                    }
                    if (item.systemFuctionName == "White Lable") {
                      // console.log(
                      //   "item systemFuctionName ",
                      //   item.systemFuctionName
                      // );
                      if (whitelabels[0]) {
                        navigate(whitelabels[0].route);
                      }
                      return;
                    }
                    navigate(item?.route);
                  }}
                  sx={{
                    background: "linear-gradient(to right, #0c0079, #e4e2f4)",
                    // active === index
                    //   ? "linear-gradient(to right, #0c0079, #e4e2f4)"
                    //   : "",
                    // color: active === index ? "white" : "black",
                    color: "white",
                    // fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        f
                        sx={{
                          fontWeight: currentPage === index ? 600 : 400,
                          fontSize: {
                            xs: "13px",
                            sm: "12px",
                            md: "15px",
                            lg: "1rem",
                          },
                        }}
                      >
                        {item?.label == "Billing"
                          ? item.label
                          : titleHead1(item)}
                      </Typography>
                    }
                  />
                  {/* {active === index ? <ExpandLess /> : <ExpandMore />} */}
                  <Box
                    component={ExpandMore}
                    sx={{
                      transform: "rotate(0deg)",
                      // active === index ? "rotate(0deg)" : "rotate(-90deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </ListItemButton>
                {
                  item.systemFuctionName == "Dashboard" &&
                    barName == "analatic" && <Analatic />
                  // <Menu  data={item.tab}/>
                  // <Menu data={analatics} collapse={currentPage === index && item.tab ?true:false}/>
                }
                {item.systemFuctionName == "Customer Management" &&
                  barName == "CustomerMangment" && (
                    <CustomerMangementbar menuLoginHeader={menuLoginHeader} />
                  )}
                {item.systemFuctionName == "Business Management" &&
                  barName == "bussinessMangment" && (
                    <BussinessMangment menuLoginHeader={menuLoginHeader} />
                  )}
                {item.systemFuctionName == "Bills" && barName == "billing" && (
                  <BillingBarSide menuLoginHeader={menuLoginHeader} />
                )}
                {item.systemFuctionName == "My Institute" &&
                  barName == "institute" && (
                    <InstituteSidebar menuLoginHeader={menuLoginHeader} />
                  )}
                {item.systemFuctionName == "My Franchise" &&
                  barName == "franchise" && (
                    <FranchiseSidebar menuLoginHeader={menuLoginHeader} />
                  )}
                {item.systemFuctionName == "Post Consultant Ads" &&
                  barName == "consultant" && (
                    <ConsultantSidebar menuLoginHeader={menuLoginHeader} />
                  )}
                {item.systemFuctionName == "White Lable" &&
                  barName == "whitelabels" && (
                    <WhiteLabelsSidebar menuLoginHeader={menuLoginHeader} />
                  )}
              </React.Fragment>
            );
          })}
        {/* <ListItemButton><ListItemText primary="Business Management" /></ListItemButton>
                <ListItemButton><ListItemText primary="Customer Management" /></ListItemButton>
                <ListItemButton><ListItemText primary="Billing" /></ListItemButton> */}
      </List>
    </Box>
  );
};

export default AnalaticSideBarT;
